import '.ag{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.hk{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.z{justify-content:center;}.ssr-plugin'
import '.ay{align-items:flex-start;}.ssr-plugin'
import '.db{padding:2rem;}.ssr-plugin'
import '.di{background:var(--palette-white);}.ssr-plugin'
import '.aq{overflow:hidden;}.ssr-plugin'
import '.by{position:absolute;}.ssr-plugin'
import '.jj{top:50%;}.ssr-plugin'
import '.jk{right:1rem;}.ssr-plugin'
import '.jl{transform:translateY(-50%);}.ssr-plugin'
import '.jm{width:120px;}.ssr-plugin'
import '.jn{height:120px;}.ssr-plugin'
import '.jo{z-index:0;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.ij{z-index:1;}.ssr-plugin'
import '.a2{gap:0.5rem;}.ssr-plugin'
import '.jp{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ag l hk d e z ay db di aq"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="by jj jk jl jm jn jo d y z"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ag ij d e ay a2 jp"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
